import React, {useState, useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Button } from 'react-bootstrap'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { register } from '../actions/userActions'


function RegisterScreen() {
    const [name,            setName]            = useState('')
    const [email,           setEmail]           = useState('')
    const [password,        setPassword]        = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [messageError,    setMessageError]    = useState('')
    const dispatch     = useDispatch()
    const navigate     = useNavigate()
    const userRegister = useSelector(state => state.userRegister)
    const { loading, error, userInfo } = userRegister

    useEffect(() => {
        if (userInfo && userInfo?._id) navigate('/')
    }, [userInfo, navigate])

    const submitHandler = (e) => {
        e.preventDefault()
        if (password !== confirmPassword) {
            setMessageError('Passwords do not match')
        } else {
            setMessageError('')
            dispatch(register(name, email, password))
        }
    }

    return (
        <div style={{ minHeight: 'calc(100vh - 130px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem' }}>
            <div style={{ width: '100%', maxWidth: '440px' }} className="bnb-auth-card">

                {/* ── Card header ── */}
                <div style={{
                    background: 'linear-gradient(135deg, var(--bnb-navy) 0%, #001f5c 60%, #0a0a2e 100%)',
                    borderRadius: '10px 10px 0 0',
                    padding: '2.25rem 2rem 2rem',
                    textAlign: 'center',
                    color: '#fff',
                }}>
                    <div className="bnb-auth-icon-wrap">
                        <i className="fa-solid fa-user-plus bnb-auth-icon"></i>
                    </div>
                    <div className="bnb-auth-club-name">
                        <span>BNB</span> Golf Club
                    </div>
                    <div className="bnb-auth-subtitle">Create your account</div>
                </div>

                {/* ── Card body ── */}
                <div className="bnb-card bnb-auth-body" style={{ borderRadius: '0 0 10px 10px', padding: '2rem' }}>
                    {messageError && <Message variant="danger">{messageError}</Message>}
                    {error        && <Message variant="danger">{error}</Message>}
                    {loading      && <Loader />}

                    <Form onSubmit={submitHandler}>
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label style={{ fontWeight: '600', fontSize: '0.85rem' }}>Full Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                placeholder="John Smith"
                                value={name}
                                onChange={e => setName(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="email">
                            <Form.Label style={{ fontWeight: '600', fontSize: '0.85rem' }}>Email Address</Form.Label>
                            <Form.Control
                                required
                                type="email"
                                placeholder="your@email.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="password">
                            <Form.Label style={{ fontWeight: '600', fontSize: '0.85rem' }}>Password</Form.Label>
                            <Form.Control
                                required
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group className="mb-4" controlId="passwordConfirm">
                            <Form.Label style={{ fontWeight: '600', fontSize: '0.85rem' }}>Confirm Password</Form.Label>
                            <Form.Control
                                required
                                type="password"
                                placeholder="••••••••"
                                value={confirmPassword}
                                onChange={e => setConfirmPassword(e.target.value)}
                            />
                        </Form.Group>

                        <Button
                            type="submit"
                            className="w-100"
                            style={{
                                background: 'var(--bnb-navy)', border: 'none',
                                fontWeight: '700', textTransform: 'uppercase',
                                letterSpacing: '0.08em', fontSize: '0.85rem',
                                padding: '0.65rem',
                            }}
                        >
                            Create Account
                        </Button>
                    </Form>

                    <div style={{ borderTop: '1px solid var(--bnb-border)', marginTop: '1.5rem', paddingTop: '1.25rem', textAlign: 'center', fontSize: '0.875rem', color: 'var(--bnb-gray)' }}>
                        Already a member?{' '}
                        <Link to="/login" style={{ color: 'var(--bnb-navy)', fontWeight: '700' }}>Sign in</Link>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default RegisterScreen
